import { gql, useQuery } from '@apollo/client';
import { GroupResources } from '../../../models/types';

export interface GroupResourceVars {
  domainIdentifier: string;
}

export interface GroupResourcesData {
  domain: {
    domainIdentifier: string;
    esVersion: string;
    resources: {
      GROUP: GroupResources;
    };
  };
}

const GROUP_INFO = gql`
  query getDomainDetails($domainIdentifier: String!, $piezoArtifacts: JSON) {
    domain(domainIdentifier: $domainIdentifier, piezoArtifacts: $piezoArtifacts) {
      domainIdentifier
      esVersion
      resources {
        GROUP
      }
    }
  }
`;

export const useGroupInfoQuery = (vars: GroupResourceVars) => {
  // piezoLink auto-derives esVersion + resources.GROUP artifacts from the selection set
  // (signing/fieldRegistry) and injects the $piezoArtifacts map.
  return useQuery<GroupResourcesData, GroupResourceVars>(GROUP_INFO, {
    variables: { ...vars },
    errorPolicy: 'all',
  });
};
